import { useQuery } from '@tanstack/react-query';
import Api from 'hooks/Api';
import { useAppWrapperContext } from 'ui/layouts/AppWrapper';
import c from 'utils/constants';
import { useAdminParams } from 'utils/helpers';
import { useProvider } from 'utils/providers/Provider';

interface PROPS {
  enabled?: boolean;
}

export default function useGetAccountUser({ enabled }: PROPS = {}) {
  const { state } = useProvider();
  const args = state;
  const { accountId, accountUserId } = useAdminParams();
  const { dispatch } = useAppWrapperContext();

  return useQuery({
    queryKey: [c.ACCOUNT_USER, accountId, accountUserId],
    queryFn: async () => {
      const api = new Api(args);

      const data = await api.get({
        url: `api/v2/accounts/${accountId}/users/${accountUserId}`,
      });

      return data?.data;
    },
    onError: () => {
      if (dispatch) dispatch(false);
      window.location.href = `/accounts`;
    },
    enabled,
  });
}
